const ITEM = {
  name: 'collection',
  title: [
    { template: '{loanNo}', fieldKey: 'loanNo' },
    { template: '{lockedId}', fieldKey: 'lockedId', icon: 'fad fa-lock text-red-darker' }
  ],
  subTitle: [
    { template: '{firstName} {middleName} {lastName}', valueClass: 'subheader' },
    { template: '{source}', valueClass: 'text-right' }
  ],
  sectionFields: [
    { label: 'Disbursement Date', template: '{effectiveDate}', fieldKey: 'effectiveDate', format: 'date', valueClass: 'text-right' },
    { label: 'Amount Financed', template: '{loanAmount}', fieldKey: 'loanAmount', format: 'currency', valueClass: 'text-right' },
    { label: 'Initial Advance', template: '{approvedAmount}', fieldKey: 'approvedAmount', format: 'currency', valueClass: 'text-right' },
    { label: 'Sent At', template: '{sentAt}', fieldKey: 'sentAt', format: 'datetime', labelClass: 'f-w-600', valueClass: 'text-right', icon: 'fas fa-envelope-square' },
    { label: 'Signed At', template: '{signedAt}', fieldKey: 'signedAt', format: 'datetime', labelClass: 'f-w-600', valueClass: 'text-right', icon: 'fas fa-pen-square' },
    { label: 'Updated At', template: '{updatedAt}', fieldKey: 'updatedAt', format: 'datetime', labelClass: 'f-w-600', valueClass: 'text-right' },
    { label: 'Entered At', template: '{enteredAt}', fieldKey: 'enteredAt', format: 'datetime', labelClass: 'f-w-600', valueClass: 'text-right' },
    { label: 'Submitted By', template: '{firstName} {middleName} {lastName}', fieldKey: 'submittedBy', labelClass: 'f-w-600', valueClass: 'text-right' },
    { label: 'Rejected By', template: '{firstName} {middleName} {lastName}', fieldKey: 'rejectedBy', labelClass: 'f-w-600', valueClass: 'text-right' },
    { label: 'Days Old', template: '{daysOld}', fieldKey: 'daysOld', labelClass: 'f-w-600', valueClass: 'text-right' },
    { template: '{loanStatusText}', fieldKey: 'loanStatusText' },
    { template: '{notes}', fieldKey: 'notes', valueClass: 'notes', divider: true }
  ]
}
export default ITEM
